import {
  HttpErrorResponse,
  HttpHeaders,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthHttpService } from '@app/core/services/http';

let isRefreshing = false;
let refreshSubject = new Subject<string>();

export const authInterceptorFn: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthHttpService);

  const accessToken = localStorage.getItem('accessToken');
  let headers = new HttpHeaders({});

  if (req.url.includes('https://api-server.retailbox.uz/api/v1/exchange/shops')) {
    headers = headers.set('Authorization', 'Basic YWRtaW46bHR5YmM5MSE=');
  } else if (accessToken) {
    headers = headers.set('Authorization', `Bearer ${accessToken}`);
  }

  const authorizedReq = req.clone({ headers });

  return next(authorizedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isAuthEndpoint(authorizedReq)) {
        return handle401(authorizedReq, next, authService);
      }
      return throwError(() => error);
    })
  );
};

function isAuthEndpoint(request: HttpRequest<unknown>): boolean {
  return request.url.includes('/users/login') || request.url.includes('/users/refresh');
}

function handle401(
  req: HttpRequest<unknown>,
  next: (req: HttpRequest<unknown>) => Observable<any>,
  authService: AuthHttpService
) {
  if (!isRefreshing) {
    isRefreshing = true;
    refreshSubject = new Subject<string>();

    return authService.refreshAccessToken().pipe(
      switchMap(tokens => {
        isRefreshing = false;
        refreshSubject.next(tokens.accessToken);
        refreshSubject.complete();
        const cloned = req.clone({
          headers: (req.headers || new HttpHeaders()).set(
            'Authorization',
            `Bearer ${tokens.accessToken}`
          ),
        });
        return next(cloned);
      }),
      catchError(err => {
        isRefreshing = false;
        refreshSubject.error(err);
        authService.logout();
        return throwError(() => err);
      })
    );
  } else {
    return refreshSubject.pipe(
      filter(token => !!token),
      take(1),
      switchMap(newAccessToken => {
        const cloned = req.clone({
          headers: (req.headers || new HttpHeaders()).set(
            'Authorization',
            `Bearer ${newAccessToken}`
          ),
        });
        return next(cloned);
      })
    );
  }
}
